// extracted by mini-css-extract-plugin
export default {"root":"TrafficFunnel_root__v75ir"};